import { EOrder, EOrderBy } from '@configs/interface.config'

export enum EAppConfigType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  JSON = 'json',
}

export enum EAppConfigPlatform {
  ALL = 'all',
  IOS = 'ios',
  ANDROID = 'android',
}

export type TAppConfig = {
  id: number
  key: string
  value: string | null
  type: EAppConfigType
  platform: EAppConfigPlatform
  group: string | null
  description: string | null
  isPublic: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export type TCreateAppConfig = {
  key: string
  value?: string | null
  type: EAppConfigType
  platform?: EAppConfigPlatform
  group?: string | null
  description?: string | null
  isPublic?: boolean
  isActive?: boolean
}

export type TUpdateAppConfig = Partial<TCreateAppConfig>

export type TQueryAppConfig = {
  page: number
  limit: number
  order?: EOrder
  orderBy?: EOrderBy
  s?: string
  group?: string
  platform?: EAppConfigPlatform
}
